module.exports = TalendDesignTokens;